import React, {useState, useEffect} from 'react';
import { NavLink } from 'react-router-dom';
import pathName from '../data/pathName.json';
import '../scss/layout/_sidebar.scss';
import moment from 'moment';
import axios from 'axios';
import API from '../middleware/API';
import {GetStoreRole,GetStoreDetailRole} from '../const/constant';
import { lowerFirst } from 'lodash';
import { shallowEqual,useSelector,useDispatch    } from 'react-redux';

function Slidebar() {
  const leaveRecState = useSelector(state => state.LeaveRecState, shallowEqual)
  const dispatch = useDispatch()
  const storeId = localStorage.getItem('current_store_id') ;
  const roleId = GetStoreRole(localStorage.getItem('current_store_id'));
    const detailroleId = GetStoreDetailRole(localStorage.getItem('current_store_id')) ;

  localStorage.getItem('current_store_id') === '2'? localStorage.getItem('detailroleId2'):localStorage.getItem('detailroleId3');

  const [overtimePendings,setOvertimePendings] = useState(0)
  const [pendingRentalls,setPendingRentalls] = useState(0)
  useEffect(() => {
    if(localStorage.getItem('current_store_id') != null){
      const role = GetStoreRole(localStorage.getItem('current_store_id'))  ;
      const isAdmin = role === '2' || role === '1' || role === '3'|| role === '5';
      if(localStorage.getItem('isLogin') && localStorage.getItem('current_store_id')&& isAdmin ||detailroleId==='17' ||detailroleId==='19'  ){
  
  
        axios.all([
          API.get('LeaveRec/Pending/S'),
          API.get('Overtime/Pending/S'),
          API.get('Pending/Rentall/')
        ])
          .then(axios.spread((leaveReports, overtimeReports, pendingRentall) => {
            if(leaveReports)
              dispatch({ type: 'GET_ALL_LEAVEREC_SUCCESS',result:leaveReports})
            if (overtimeReports) {          
              setOvertimePendings(overtimeReports.totalCount)
            }   
            if (pendingRentall) {          
              setPendingRentalls(pendingRentall.totalCount)
            }      
        }));
  
        var iii = setInterval(() => {
          axios.all([
            API.get('LeaveRec/Pending/S'),
            API.get('Overtime/Pending/S'),
            API.get('Pending/Rentall/')
          ])
            .then(axios.spread((leaveReports, overtimeReports, pendingRentall) => {
              if(leaveReports)
                dispatch({ type: 'GET_ALL_LEAVEREC_SUCCESS',result:leaveReports})
              if (overtimeReports) {          
                setOvertimePendings(overtimeReports.totalCount)
              }  
              if (pendingRentall) {          
                setPendingRentalls(pendingRentall.totalCount)
              }      
          }));
        }, 60 * 1000)
  
  
  
        // 指定如何在這個 effect 之後執行清除：
        return function cleanup() {
          clearInterval(iii);
        };
      }
    }
    
  },[leaveRecState.leaveRecList.totalCount, localStorage.getItem('isLogin'), localStorage.getItem('current_store_id')]);

  const role = GetStoreRole(localStorage.getItem('current_store_id')) ;
  const detailrole = GetStoreDetailRole(localStorage.getItem('current_store_id')) ;

  const closeMenu = () => {
    document.getElementById('toggle-menu').checked = false;
  };

  function toggleThisMenu(select) {
    const dom = document.querySelector(select);
    const numberOfChildren = dom.children.length;
    const heightOfChildren = dom.children[0].clientHeight;
    if (dom.style.height === '' || dom.style.height === '0px') {
      dom.style.height = `${numberOfChildren * heightOfChildren}px`;
    } else {
      dom.style.height = '0px';
    }
  }
  const drawTab = item => 
    <li key={item.id} id={item.link}>
      <NavLink to={`/${item.link === 'dailyCostByHour'?  item.link+'/'+moment().format('YYYY-MM-DD'): item.link}`} isActive={(match, location) => {
        if (location.pathname.indexOf(item.link) === -1) {
          return false;
        }else{
          return true;
        }
        }} onClick={closeMenu} activeClassName="active">{item.name}
      </NavLink>        
      {
        item.name === '簽核假單'? <span className="badge">{leaveRecState.leaveRecList.totalCount}</span>:
        item.name === '簽核加班單'? <span className="badge">{overtimePendings}</span>:
        item.name === '場租列表'? <span className="badge">{pendingRentalls}</span>:
        ''
      }
    </li>;
  //const drawTab = item => <li key={item.id} id={item.link}><NavLink to={`/${item.link}`} exact onClick={closeMenu} activeClassName="active">{item.name}</NavLink></li>;
  const drawSideBar = _pathName => _pathName.filter(function(element) {
    if (element.id === 14 && localStorage.getItem('current_store_id') === '2') {
      return false; // skip
    }
    if (element.id === 23 && (roleId == '3' || roleId == '8' || roleId == '11')) {
      return false; // skip
    }
    if(element.id === 25 && storeId != 1){
      return false;
    }

    return true;
  }).map((item) => {
    let blockItem = '';
    if ('children' in item) {
      blockItem = (
        <li id={item.name} key={item.id}>
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              toggleThisMenu(`.child-block-${item.link}`);
            }}
          >
            {item.name}
            {' '}
            <i className="fas fa-angle-down" />
          </a>
          <ul className={`child-block-${item.link}`}>
            {
              drawSideBar(item.children)
            }
          </ul>
        </li>
      );

    } else if (item.auth === 'all') {
      blockItem = drawTab(item);
    } else if (item.auth.some(_item => _item === Number(role)) 
      || (item.id === 10 && detailrole == '8')
      || (item.id === 10 && detailrole == '11')
      || (item.id === 222 && detailrole == '17')
      || (item.id === 222 && detailrole == '19')) {
      blockItem = drawTab(item);
    } else if (item.link === 'signinsalarymanagement' && localStorage.getItem('username') === '0933089198') {
      blockItem = drawTab(item);
    }
    return blockItem;
  });
  return (
    <div className="l-slidebar" style={{ backgroundColor: (localStorage.getItem('current_store_id') === '2' ||localStorage.getItem('current_store_id') === '3')?'#415497':''}}>
      <label htmlFor="toggle-menu" className="l-slidebar__closed" />
      <ul className="l-slidebar__nav-bar">
        {
          drawSideBar(pathName)
        }
      </ul>
    </div>
  );
}

export default Slidebar;